const mappingPrestation = {
  "Carte de Fidelité": "EQUIPEMENT ET ACCESSOIRES",
  "Chaines neige Budget": "EQUIPEMENT ET ACCESSOIRES",
  "Chaînes VU": "EQUIPEMENT ET ACCESSOIRES",
  "Chaînes VP": "EQUIPEMENT ET ACCESSOIRES",
  "Don associatif": "EQUIPEMENT ET ACCESSOIRES",
  "Pack de 20 cartons": "EQUIPEMENT ET ACCESSOIRES",
  "Pack Déménagement Confort": "EQUIPEMENT ET ACCESSOIRES",
  "Réhausseur Enfant de 15 à 35 kg": "EQUIPEMENT ET ACCESSOIRES",
  Diable: "EQUIPEMENT ET ACCESSOIRES",
  GPS: "EQUIPEMENT ET ACCESSOIRES",
  "Pack de 5 cartons": "EQUIPEMENT ET ACCESSOIRES",
  "Pack de 10 cartons": "EQUIPEMENT ET ACCESSOIRES",
  "Pack Déménagement Standard": "EQUIPEMENT ET ACCESSOIRES",
  "Frais garantie Chèques de caution": "EQUIPEMENT ET ACCESSOIRES",
  Ethylotest: "EQUIPEMENT ET ACCESSOIRES",
  "Rouleau adhésif": "EQUIPEMENT ET ACCESSOIRES",
  "Film à bulle": "EQUIPEMENT ET ACCESSOIRES",
  "Sangle arrimage": "EQUIPEMENT ET ACCESSOIRES",
  "Couverture de déménagement": "EQUIPEMENT ET ACCESSOIRES",
  "Siège Enfant de 9 à 18 kg": "EQUIPEMENT ET ACCESSOIRES",
  "Pack Hiver": "EQUIPEMENT ET ACCESSOIRES",
  "Pneus Hiver": "EQUIPEMENT ET ACCESSOIRES",
  "Renouvellement Carte de Fidelité": "EQUIPEMENT ET ACCESSOIRES",
  Promotion: "EQUIPEMENT ET ACCESSOIRES",
  "Non Restitution d'Ethylotest": "EQUIPEMENT ET ACCESSOIRES",
  "Kit Déménagement": "EQUIPEMENT ET ACCESSOIRES",
  Chaines: "EQUIPEMENT ET ACCESSOIRES",
  Galerie: "EQUIPEMENT ET ACCESSOIRES",
  "Plateau à roulettes": "EQUIPEMENT ET ACCESSOIRES",
  "Siège Bébé jusqu'à 9 kg": "EQUIPEMENT ET ACCESSOIRES",
  "Pneus hiver VP": "EQUIPEMENT ET ACCESSOIRES",
  "Pneus hiver VU": "EQUIPEMENT ET ACCESSOIRES",
  "Siège Bébé Budget": "EQUIPEMENT ET ACCESSOIRES",
  "Poussette canne": "EQUIPEMENT ET ACCESSOIRES",
  "Lit Parapluie": "EQUIPEMENT ET ACCESSOIRES",
  ATTELAGE: "EQUIPEMENT ET ACCESSOIRES",
  "Rachat de Franchise": "ASSURANCE",
  Carburant: "PRESTATIONS DE SERVICE",
  "Franchises /  Carburant": "PRESTATIONS DE SERVICE",
  "Matmut Dégâts": "DEGATS / REMISE EN ETAT",
  "Matmut Franchise Sociétaire": "DEGATS / REMISE EN ETAT",
  "Franchise réduite accident": "DEGATS / REMISE EN ETAT",
  "Franchise Super réduite accident": "DEGATS / REMISE EN ETAT",
  "Franchise Totale accident": "DEGATS / REMISE EN ETAT",
  "Franchise réduite vol": "DEGATS / REMISE EN ETAT",
  "Franchise Totale vol": "DEGATS / REMISE EN ETAT",
  "Remise en état": "DEGATS / REMISE EN ETAT",
  "Dégâts Sinistres BUDGET": "DEGATS / REMISE EN ETAT",
  "Frais de dossier sinistre": "DEGATS / REMISE EN ETAT",
  "FACTURATION PV / FPS": "PV / FPS",
  "FRAIS DE GESTION PV / FPS": "PV / FPS",
  "Frais d'annulation": "FRAIS DE DOSSIER",
  "NO-SHOW": "FRAIS DE DOSSIER",
  "FRAIS DE GESTION PV ETRANGER": "FRAIS DE DOSSIER",
  "FRAIS D EXPERTISE": "FRAIS DE DOSSIER",
  "Frais d'Immobilisation": "FRAIS DE DOSSIER",
  "Pack Sécurité": "ASSURANCE",
  "Pack Sérénité": "ASSURANCE",
  "Pack Sécurité Plus": "ASSURANCE",
  "Location / Prestations": "LOCATION",
  "Assurlocauto VP": "OPTION DE LOCATION & ASSISTANCE",
  "COEUR DE FORET - DON": "OPTION DE LOCATION & ASSISTANCE",
  "Assistance Technique et Médicale": "OPTION DE LOCATION & ASSISTANCE",
  "Jeune Conducteur": "OPTION DE LOCATION & ASSISTANCE",
  "Rachat de Franchise (Super CDW) ! MAROC uniquement":
    "OPTION DE LOCATION & ASSISTANCE",
  "Assistance Technique et Médicale (Promo)": "OPTION DE LOCATION & ASSISTANCE",
  "Conducteur Additionnel (Promo)": "OPTION DE LOCATION & ASSISTANCE",
  "Réduction de Franchise Accident": "OPTION DE LOCATION & ASSISTANCE",
  "Réduction de Franchise Super Réduite": "OPTION DE LOCATION & ASSISTANCE",
  "Réduction de Franchise VOL": "OPTION DE LOCATION & ASSISTANCE",
  "Conducteur Additionnel": "OPTION DE LOCATION & ASSISTANCE",
  "Départ Vendredi Après-Midi": "OPTION DE LOCATION & ASSISTANCE",
  "Retour en retard": "OPTION DE LOCATION & ASSISTANCE",
  "ATM FREELOC": "OPTION DE LOCATION & ASSISTANCE",
  "Conducteur Additionnel BUDGET": "OPTION DE LOCATION & ASSISTANCE",
  "Réduction de Franchise VOL BUDGET": "OPTION DE LOCATION & ASSISTANCE",
  "Réduction de Franchise Super Réduite BUDGET":
    "OPTION DE LOCATION & ASSISTANCE",
  "Assistance Technique et Médicale BUDGET": "OPTION DE LOCATION & ASSISTANCE",
  "Réduction de Franchise Accident BUDGET": "OPTION DE LOCATION & ASSISTANCE",
  "Jeune conducteur Budget": "OPTION DE LOCATION & ASSISTANCE",
  "Annulation et modification flexible": "OPTION DE LOCATION & ASSISTANCE",
  "FONDATION DE L'ARMEE DU SALUT - DON": "OPTION DE LOCATION & ASSISTANCE",
  "GREENMINDED - DON": "OPTION DE LOCATION & ASSISTANCE",
  "CARE - DON": "OPTION DE LOCATION & ASSISTANCE",
  "Assistance Technique et Médicale Premium": "OPTION DE LOCATION & ASSISTANCE",
  "SECOURS POPULAIRE - DON": "OPTION DE LOCATION & ASSISTANCE",
  "Assurlocauto VU": "OPTION DE LOCATION & ASSISTANCE",
  "Primes de Volumes Constructeur": "PRIME DE VOLUME CONTRUCTEUR",
  "Prestation carburant": "PRESTATIONS DE SERVICE",
  "Frais d'Astreinte Départ": "PRESTATIONS DE SERVICE",
  Abandon: "PRESTATIONS DE SERVICE",
  "Livraison/Reprise (obligatoire client)": "PRESTATIONS DE SERVICE",
  "FASTT Quote-Part Conducteur": "PRESTATIONS DE SERVICE",
  Surclassement: "PRESTATIONS DE SERVICE",
  "Abandon Assisteurs auto VU": "PRESTATIONS DE SERVICE",
  "Nettoyage du véhicule": "PRESTATIONS DE SERVICE",
  "Frais d'Astreinte Retour": "PRESTATIONS DE SERVICE",
  "Taxe Environnementale": "PRESTATIONS DE SERVICE",
  "Abandon Budget": "PRESTATIONS DE SERVICE",
  "Frais d'Astreinte BUDGET": "PRESTATIONS DE SERVICE",
  "Livraison Reprise BUDGET": "PRESTATIONS DE SERVICE",
  "Transfert Navette (obligatoire client)": "PRESTATIONS DE SERVICE",
  Reprise: "PRESTATIONS DE SERVICE",
  "Abandon Assisteurs auto VP": "PRESTATIONS DE SERVICE",
  "Remise 1 jour non utilisé": "PRESTATIONS DE SERVICE",
  "Easy Péage": "PRESTATIONS DE SERVICE",
  Livraison: "PRESTATIONS DE SERVICE",
  "Geste commercial incident": "GESTE COMMERCIAL",
  "Matmut - VEH Hors Protocole": "GESTE COMMERCIAL",
  "Remise SPB": "GESTE COMMERCIAL",
  Remise: "GESTE COMMERCIAL",
  "Km supplémentaire": "LOCATION",
  "Jour supplémentaire": "LOCATION",
  Forfait: "LOCATION",
  "Surcharge Gare (obligatoire client)": "PRESTATIONS DE SERVICE",
  "Surcharge Stationnement (obligatoire client)": "PRESTATIONS DE SERVICE",
  "Taxe portuaire (obligatoire client)": "PRESTATIONS DE SERVICE",
  "Particpation aux coûts d'immatriculation BUDGET": "PRESTATIONS DE SERVICE",
  "Surcharge Aéroport BUDGET": "PRESTATIONS DE SERVICE",
  "Participation à L'éco Taxe": "PRESTATIONS DE SERVICE",
  "Surcharge Aéroport": "PRESTATIONS DE SERVICE",
  "Particpation aux coûts d'immatriculation": "PRESTATIONS DE SERVICE",
  "Cession de Véhicule Immo": "CESSION DE VEHICULE",
  "Cession de Véhicule Stock": "CESSION DE VEHICULE",
  null: "Complément de location",
};

export const getPrestationTypeFromLabel = (label: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return mappingPrestation[label];
};
